import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

type Severities = 'success' | 'info' | 'warn' | 'error';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  toastNotificationChange: Subject<Object> = new Subject<Object>();
  growlNotificationChange: Subject<Object> = new Subject<Object>();
  messageNotificationChange: Subject<Object> = new Subject<Object>();

  private message = signal<any[]>([]);

  messageNotifyNow() {
    this.messageNotificationChange.next(this.message);
    this.message.set([]);
  }

  notificationClear() {
    this.message.set([]);
    this.messageNotifyNow();
  }

  toastNotify(severity: Severities, summary: string, detail: string) {
    this.toastNotificationChange.next({ severity, summary, detail });
  }

  messageNotify(severity: Severities, summary: string, detail: string) {
    this.messageNotificationChange.next([{ severity, summary, detail }]);
  }

  addNotification(severity: Severities, summary: string, detail: string) {
    this.message.set([{ severity, summary, detail }]);
  }
}
